import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
    SalesInvoiceServiceProxy,
    SalesDto,
    Status,
    PaymentStatus,
    TaxType,
    PurchaseType,
    EntityDto,
    AccountJournalServiceProxy,
} from '@shared/service-proxies/service-proxies';

import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { HttpClient } from '@angular/common/http';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { finalize } from 'rxjs';
import { UtilsService } from 'app/shared/common/utils/utils-service';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';
import { environment } from 'environments/environment';


@Component({
    templateUrl: './journalvouchers.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class JournalVouchersComponent extends AppComponentBase {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('ExcelFileUpload', { static: false }) excelFileUpload: FileUpload;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;

    advancedFiltersAreShown = false;
    filterText = '';

    maxPTaxFilter: number;
    maxPTaxFilterEmpty: number;
    minPTaxFilter: number;
    minPTaxFilterEmpty: number;
    vendorDisplayPropertyFilter = '';
    currencyNameFilter = '';
    paymentTermNameFilter = '';

    status = Status;
    paymentStatus = PaymentStatus;
    taxType = TaxType;
    purchaseType = PurchaseType;

    uploadUrl: string;

    constructor(
        injector: Injector,
        private _accountJournalServiceProxy: AccountJournalServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _httpClient: HttpClient,
        public utilsService: UtilsService
    ) {
        super(injector);

        this.uploadUrl = AppConsts.remoteServiceBaseUrl + '/SalesInvoices/ImportFromExcel';
    }

    getJournalVouchers(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();
       
        this._accountJournalServiceProxy
            .getAll(
                this.filterText,
                false,
                this.appSession.user.locationId,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
                this.primengTableHelper.getSkipCount(this.paginator, event)
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createJournalVoucher(): void {
        this._router.navigate(['/app/account/journalVouchers/createOrEdit']);
    }

    print(id:number): void{
        window.open(AppConsts.remoteServiceBaseUrl + '/Account/JournalVoucher/' + id, '_blank');
    }

    deleteJournalVoucher(purchaseOrder: SalesDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._accountJournalServiceProxy.deleteJournalVoucher(purchaseOrder.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }


    exportToExcel($event): void {
        //this._accountJournalServiceProxy
        //    .getSalesInvoicesToExcel(
        //        this.filterText,
        //        $event,
        //        this.maxPTaxFilter == null ? this.maxPTaxFilterEmpty : this.maxPTaxFilter,
        //        this.minPTaxFilter == null ? this.minPTaxFilterEmpty : this.minPTaxFilter,
        //        this.vendorDisplayPropertyFilter,
        //        undefined,
        //        this.currencyNameFilter,
        //        undefined,
        //        this.paymentTermNameFilter,
        //        undefined,
        //    )
        //    .subscribe((result) => {
        //        this._fileDownloadService.downloadTempFile(result);
        //    });
    }

    uploadExcel(data: { files: File }): void {
        const formData: FormData = new FormData();
        const file = data.files[0];
        formData.append('file', file, file.name);

        this._httpClient
            .post<any>(this.uploadUrl, formData)
            .pipe(finalize(() => this.excelFileUpload.clear()))
            .subscribe((response) => {
                if (response.success) {
                    this.notify.success(this.l('ImportSalesInvoiceProcessStart'));
                } else if (response.error != null) {
                    this.notify.error(this.l('ImportSalesInvoicesUploadFailed'));
                }
            });
    }

    onUploadExcelError(): void {
        this.notify.error(this.l('ImportSalesInvoicesUploadFailed'));
    }

    resetFilters(): void {
        this.filterText = '';
        this.maxPTaxFilter = this.maxPTaxFilterEmpty;
        this.minPTaxFilter = this.maxPTaxFilterEmpty;
        this.vendorDisplayPropertyFilter = '';
        this.currencyNameFilter = '';
        this.paymentTermNameFilter = '';

        this.getJournalVouchers();
    }

    showExcelColumnSelectionModal() {
        //this._accountJournalServiceProxy.getSalesInvoiceExcelColumnsToExcel().subscribe((result) => {
        //    this.excelColumnSelectionModal.show(result);
        //});
    }

}
